import type { BlogRegion } from "./types";

const STATIC_IMAGES_URL = "https://static-assets.amberstudent.com/images";

const ukFlag = `${STATIC_IMAGES_URL}/uk.svg`;
const usaFlag = `${STATIC_IMAGES_URL}/usa.svg`;
const germanyFlag = `${STATIC_IMAGES_URL}/germany.svg`;
const australiaFlag = `${STATIC_IMAGES_URL}/australia.svg`;

export const BLOG_REGIONS: BlogRegion[] = [
  {
    slug: "united-kingdom",
    countrySlug: "uk",
    name: "United Kingdom",
    nameKey: "blog.home.regions.uk.name",
    descriptionKey: "blog.home.regions.uk.description",
    flag: ukFlag,
  },
  {
    slug: "united-states",
    countrySlug: "usa",
    name: "United States",
    nameKey: "blog.home.regions.usa.name",
    descriptionKey: "blog.home.regions.usa.description",
    flag: usaFlag,
  },
  {
    slug: "germany",
    countrySlug: "germany",
    name: "Germany",
    nameKey: "blog.home.regions.germany.name",
    descriptionKey: "blog.home.regions.germany.description",
    flag: germanyFlag,
  },
  {
    slug: "australia",
    countrySlug: "australia",
    name: "Australia",
    nameKey: "blog.home.regions.australia.name",
    descriptionKey: "blog.home.regions.australia.description",
    flag: australiaFlag,
  },
];

export const getBlogRegion = (slug?: string): BlogRegion | undefined =>
  BLOG_REGIONS.find((region) => region.slug === slug);
